module.exports = __webpack_public_path__ + "img/geo-fence-breached.e54b13fe.svg";